import React, { useEffect, useRef } from 'react';

import RenderFieldBasedOnType from '../../../TrackerViewerV2/components/RenderFieldsBasedOnType';
import { enrichNumberElementForInlineEdit } from '../../../TrackerViewerV2/utils/formatters';
import { isDropdownColumn } from '../../utils';

/**
 * Renders a single inline editor and auto-focuses text-like controls.
 */
const InlineEditableCell = (props) => {
    const {
        column,
        dataObj,
        onChange,
        inputClasses,
        editorClassName,
        fieldProps,
    } = props;

    const wrapperRef = useRef(null);
    const isDropdownField = isDropdownColumn(column);
    const editorElement = enrichNumberElementForInlineEdit({
        ...column,
        readOnly: column.readOnly,
    });

    useEffect(() => {
        if (isDropdownField) {
            return;
        }

        const root = wrapperRef.current;
        if (!root) {
            return;
        }

        const focusTarget = root.querySelector(
            'input:not([type="hidden"]), textarea, [role="combobox"], [contenteditable="true"]',
        );

        if (focusTarget && typeof focusTarget.focus === 'function') {
            focusTarget.focus();
            if (typeof focusTarget.select === 'function' && focusTarget.tagName === 'INPUT') {
                focusTarget.select();
            }
        }
    }, [column?.value, column?.name, isDropdownField]);

    return (
        <div ref={wrapperRef} className={editorClassName}>
            <RenderFieldBasedOnType
                {...fieldProps}
                element={editorElement}
                dataObj={dataObj}
                onChange={onChange}
                handleCheckboxChange={onChange}
                inputClasses={inputClasses}
                options={column.options}
                openSelectMenuOnMount={isDropdownField}
                selectedStep={{ dataModel: fieldProps.selectedDataModel }}
            />
        </div>
    );
};

export default InlineEditableCell;
